import React, { Component } from 'react';

import Home from './components/Home/';
import Projects from './components/Projects/';
import About from './components/About/';
import Contact from './components/Contact/';
import Resume from './components/Resume/';

import '../node_modules/font-awesome/css/font-awesome.min.css';
import '../node_modules/mdi/css/materialdesignicons.min.css';



import {
  BrowserRouter as Router,
  Route,
  Switch,
} from 'react-router-dom';


class App extends Component {


  render() {
    return (
      <div>
        <Router>
          <Switch>
            <Route exact path="/" component={() => <Home />} />
            <Route path="/projects" component={() => <Projects />} />
            <Route path="/about" component={() => <About />} />
            <Route path="/contact" component={() => <Contact />} />
            <Route path="/Resume" component={() => <Resume />} />
          </Switch>
        </Router>
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js